import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics, identifyUser, initSessionTracking } from './lib/analytics';

// Initialize Mixpanel as early as possible
initAnalytics(process.env.REACT_APP_MIXPANEL_TOKEN);
// Initialize session tracking
try { initSessionTracking(); } catch (_) {}

// Early identify from cached email to avoid anonymous events on deep links
try {
  const cachedEmail = localStorage.getItem('email');
  const cachedStream = localStorage.getItem('stream');
  if (cachedEmail) {
    identifyUser(cachedEmail, { '$email': cachedEmail, stream: cachedStream || undefined });
  }
} catch (_) {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
